/** Type Predicate: check if a string or number is a valid enum value and narrow the type accordingly. Be wary of reverse
 * mappings for integer enums.
 */
export default function enumIncludes<TEnum extends {[key: string]: string | number}>(
  enumObj: TEnum,
  value: string | number | null | undefined
): value is TEnum[keyof TEnum] {
  if (value == null) {
    return false;
  }
  return Object.values(enumObj).includes(value);
}
